module.exports = __webpack_public_path__ + "img/web_sg_website_1.0433cf47.jpg";